@defer {

	@if(isSeasonOngoing) {

		<div
			class="
				py-36 px-8 grid
				grid-cols-1 grid-rows-4 gap-8
				md:grid-cols-3 md:grid-rows-3
				lg:grid-rows-4 lg:grid-cols-4
			"
			style="grid-template-rows: auto auto 1fr;"
		>
			<div
				class="
					col-span-1 row-span-1 col-start-1 row-start-1
					md:col-span-3
					lg:col-span-4
				"
			>
				<peps-bet-header></peps-bet-header>
			</div>
			<div
				class="
					col-span-1 row-span-1 col-start-1 row-start-2
				"
			>
				<peps-current-season
					[currentSeason]="currentSeason"
				></peps-current-season>
			</div>
			<div
				class="
					col-span-1 row-span-1 col-start-1 row-start-3
					md:col-span-2 md:col-start-2 md:row-start-2
					lg:col-span-1 lg:row-span-1 lg:col-start-1 lg:row-start-3
				"
			>
				<peps-top-five
					[top5Leaderboard]="top5Leaderboard"
				></peps-top-five>
			</div>
			<div
				class="
					col-span-1 row-span-1 col-start-1 row-start-4
					md:col-span-3 md:row-start-3
					lg:col-span-3 lg:row-span-3 lg:col-start-2 lg:row-start-2
				"
			>
				<div class="flex flex-col gap-4" id="matchupList">
					<div class="flex border-b border-peps-dark-600">
						<button
							(click)="selectTab('SCHEDULED')"
							[ngClass]="{
								'after:scale-x-100 text-peps-dark-200/90': selectedTab === 'SCHEDULED',
								'hover:text-peps-dark-200/90 text-peps-dark-200/60 after:scale-x-0': selectedTab !== 'SCHEDULED'
							}"
							class="relative px-4 py-2 text-sm font-notosans font-light cursor-pointer transition-colors duration-300
								after:content-[''] after:absolute after:bottom-0 after:right-0 after:h-[2px] after:w-full
								after:bg-peps-gold after:origin-right after:scale-x-0 after:transition-transform after:duration-300"
						>
							{{ 'page.bet.tab.match-upcoming' | translate }}
						</button>

						<button
							(click)="selectTab('FINISHED')"
							[ngClass]="{
								'after:scale-x-100 text-peps-dark-200/90': selectedTab === 'FINISHED',
								'hover:text-peps-dark-200/90 text-peps-dark-200/60 after:scale-x-0': selectedTab !== 'FINISHED'
							}"
							class="relative px-4 py-2 text-sm font-notosans font-light cursor-pointer transition-colors duration-300
								after:content-[''] after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full
								after:bg-peps-gold after:origin-left after:scale-x-0 after:transition-transform after:duration-300"
						>
							{{ 'page.bet.tab.match-played' | translate }}
						</button>
					</div>

					@if(selectedTab === 'FINISHED') {
						@if(matchups['FINISHED']) {

							@for(weekend of matchups['FINISHED'] | keyvalue; track weekend.key; let last = $last) {
								<span class="uppercase border-b-2 border-peps-gold w-fit">{{ weekend.key | localizedWeekendRange  }}</span>
								<div class="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-4">
									@for(matchup of weekend.value; track matchup.id) {
										<peps-bet-finished-matchup-card
											[prediction]="matchup | getUserBet: userPredictions"
											[matchup]="matchup"
										></peps-bet-finished-matchup-card>
									}
								</div>
								@if(!last){
									<span class="border-b border-peps-dark-600 my-4"></span>
								}
							}

						} @else {
							<div class="flex flex-col gap-1 justify-center items-center w-full h-full py-8">
								<span class="text-4xl uppercase">{{ 'page.bet.no-match-played' | translate }}</span>
							</div>
						}

					} @else {
						@if(matchups['SCHEDULED']) {

							@for(weekend of matchups['SCHEDULED'] | keyvalue; track weekend.key; let last = $last) {
								<span class="uppercase border-b-2 border-peps-gold w-fit">{{ weekend.key | localizedWeekendRange  }}</span>
								<div class="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-4">
									@for(matchup of weekend.value; track matchup.id) {
										<peps-bet-matchup-card
											[isBetPlaced]="matchup | isBetPlaced: userPredictions"
											[bet]="matchup | getUserBet: userPredictions"
											[matchup]="matchup"
											(selectedMatchup)="selectMatchup($event)"
											[isBetSidebarOpen]="isBetSidebarOpen"
										></peps-bet-matchup-card>

									}
								</div>
								@if(!last){
									<span class="border-b border-peps-dark-600 my-4"></span>
								}
							}
						} @else {
							<div class="flex flex-col gap-1 justify-center items-center w-full h-full py-8">
								<span class="text-4xl uppercase">{{ 'page.bet.all-match-finished' | translate }}</span>
							</div>
						}
					}
				</div>
			</div>
		</div>

		<peps-bet-sidebar
			[isBetSidebarOpen]="isBetSidebarOpen"
			(closeSidebar)="closeBetSidebar()"
			(betValidated)="onBetValidated()"
			[matchup]="selectedMatchup"
			[prediction]="currentPrediction"
		></peps-bet-sidebar>

	} @else {
		<div class="w-full h-screen flex flex-col gap-4 items-center justify-center text-peps-dark-200/80 text-2xl uppercase">
			<span>
				{{ 'page.bet.no-season' | translate }}
			</span>
			<a href="/bet/leaderboard" class="text-center bg-peps-gold text-peps-dark-700 font-semibold px-5 py-2.5 cursor-pointer hover:bg-peps-yellow transition-colors uppercase">
				{{ 'page.bet.see-past-season' | translate }}
			</a>
		</div>
	}
}
